/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */
// @ts-nocheck
import React from 'react';
import { MentionsInput, Mention } from 'react-mentions';
import autoSuggestStyles from './AutoSuggestStyle.js';
import { escapeRegExp } from 'lodash';

const autoStuggest = ({
    value,
    placeholder,
    onChange,
    mentions = [],
}: FormMentionsTextInputProps) => {
    const onMentionInputChange = e => {
        const msg = e.target.value;
        e.target.value = addMentions(msg, mentions, false);

        onChange(e);
    };
    return (
        <MentionsInput
            style={autoSuggestStyles}
            value={value}
            placeholder={placeholder}
            onChange={onMentionInputChange}
        >
            <Mention
                style={autoSuggestStyles.mention}
                displayTransform={(id, display) => `@${display}`}
                trigger={'@'}
                data={mentions}
            />
        </MentionsInput>
    );
};
export default autoStuggest;

interface FormMentionsTextInputProps {
    value: string;
    placeholder: string;
    onChange: (e: {
        target: {
            value: string;
        };
    }) => void;
    mentions: Mention[];
}

export const addMentions = (str, mentions = [], isTrim = true) => {
    if (!str) {
        return '';
    }
    const message = isTrim ? trim(str) : str;
    return mentions.reduce((acc, val) => {
        const regex = new RegExp(`@${escapeRegExp(val.display)}`, 'gi');
        const matches = acc.match(regex);
        if (matches) {
            const uniqueMatch = new Set(matches);
            let updatedAcc = acc;
            uniqueMatch.forEach(match => {
                updatedAcc = updatedAcc.replaceAll(
                    match,
                    `@[${match.slice(1)}](${val.id})`
                );
            });
            return updatedAcc;
        }

        return acc;
    }, message);
};
